import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import React, { FC } from "react";

interface SchedulerInfoRowProps {
  cellsCount: number;
  cellContent: React.ReactNode;
  rowLabel: string;
  className?: string;
}

const SchedulerInfoRow: FC<SchedulerInfoRowProps> = ({ cellsCount, cellContent, rowLabel, className }) => {
  let tableCells: JSX.Element[] = [];
  for (let i = 0; i < cellsCount; i++) {
    tableCells.push(<TableCell key={i}>{cellContent}</TableCell>);
  }

  return (
    <TableRow className={className}>
      <TableCell>{rowLabel}</TableCell>
      {tableCells}
    </TableRow>
  );
};

export default SchedulerInfoRow;
